import { Typography } from '@global-engineering-shared/gweb-material-ui';

import useStyles from 'features/Frames/components/Frames/FramesTable/components/TableCollapsedContentDetail/TableCollapsedContentDetail.styles';
import { CollapsedContentFrameDetail } from 'features/Frames/components/Frames/FramesTable/components/TableCollapsedContentDetails/utils/collapsedContentFrameDetails';
import { Frame } from 'features/Frames/types';

type FrameDetailProps = {
  frame: Frame;
  detail: CollapsedContentFrameDetail;
};

const TableCollapsedContentDetail = ({ frame, detail }: FrameDetailProps) => {
  const classes = useStyles();
  const frameDetail = frame[detail.key as keyof Omit<Frame, 'status'>];
  return (
    <div key={detail.key} className={classes.root}>
      <Typography className={classes.header}>{detail.header}: </Typography>
      <Typography fontWeight="bold" className={classes.value}>
        {frameDetail}
      </Typography>
    </div>
  );
};

export default TableCollapsedContentDetail;
